import type { CanvasKit, CanvasKitInitOptions } from "./index";

const CanvasKitInitPromise: Promise<(options: CanvasKitInitOptions) => CanvasKit> = import("./canvaskit.js").then(
  (module) => {
    const CanvasKitInit = module.default;
    if (typeof CanvasKitInit !== "function") {
      throw new Error("Failed to load CanvasKit: Module is not a function.");
    }
    return CanvasKitInit as (options: CanvasKitInitOptions) => CanvasKit;
  }
);

export default async function CanvasKitInit(options: CanvasKitInitOptions): Promise<CanvasKit> {
  const init = await CanvasKitInitPromise;
  return init(options);
}
